// Module
var code = "<div class=\"vui-stepper-content\" ng-transclude></div>\n";
// Exports
module.exports = code;